import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2.59464 21.4038C2.21696 21.0341 2 20.5359 2 20.0056C2 19.4752 2.21696 18.977 2.59464 18.6073L16.7375 5.10734C17.5089 4.36805 18.7304 4.4002 19.4616 5.17163C20.1929 5.94305 20.1687 7.16448 19.3973 7.89573L8.74196 18.077H36.0714C37.1402 18.077 38 18.9368 38 20.0056C38 21.0743 37.1402 21.9341 36.0714 21.9341H8.74196L19.4054 32.1073C20.1768 32.8466 20.2009 34.06 19.4696 34.8314C18.7384 35.6029 17.517 35.627 16.7455 34.8957L2.60268 21.3957L2.59464 21.4038Z" })
});
export default SvgArrowLeft;
